const productsData = [
    {
      image: 'https://unsplash.com/photos/gUKv_yrQ_tk',
      name: "BASIC PLAN",
      price: "25.000",
      features: [
        "100 acres",
        "Free consultaion to coaches",
        "Access to The Community",
      ],
    },
    {
        image: 'https://unsplash.com/photos/a1Lm99Kkqtg',
      name: "PREMIUM PLAN",
      price: "30.000",
      features: [
        "500 acres",
        "Free ",
        "Accessto minibar",
      ],
    },
    {
        image: 'https://unsplash.com/photos/JRUVbgJJTBM',
      name: "PRO PLAN",
      price: "45.000",
      features: [
        "1000 acres",
        "Specialist Consultation ",
        "Free maintenance",
      ],
    },
  ];

  export default productsData